// Generic IndexedDB KV helpers used by getOrFetch and anything else.
// Shares the same DB as the transactions cache to keep storage unified.
// No Firestore usage here.

const DB_NAME = "pp-cache";
const DB_VERSION = 2;       // v2 adds 'kv' store
const STORE_KV = "kv";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(req.error);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_KV)) {
        db.createObjectStore(STORE_KV, { keyPath: "key" });
      }
      // Other stores (e.g. 'txByQuery') are created by transactionsCached.js
    };
    req.onsuccess = () => resolve(req.result);
  });
}

async function withStore(mode, fn) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_KV, mode);
    const store = tx.objectStore(STORE_KV);
    let done = false;
    tx.oncomplete = () => !done && resolve();
    tx.onerror = () => !done && reject(tx.error);
    const res = fn(store);
    if (res instanceof Promise) {
      res.then((v) => { done = true; resolve(v); })
         .catch((e) => { done = true; reject(e); });
    }
  });
}

export async function idbGet(key) {
  return withStore("readonly", (store) => new Promise((resolve, reject) => {
    const req = store.get(key);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  }));
}

export async function idbSet(key, payload) {
  const rec = { key, ...payload }; // usually { value, expiresAt }
  return withStore("readwrite", (store) => { store.put(rec); });
}

export async function idbDel(key) {
  return withStore("readwrite", (store) => { store.delete(key); });
}
